module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.58aef543.ttf";